import { render, staticRenderFns } from "./TerritorialAtlasCard.vue?vue&type=template&id=43f2a989&scoped=true&"
import script from "./TerritorialAtlasCard.vue?vue&type=script&lang=js&"
export * from "./TerritorialAtlasCard.vue?vue&type=script&lang=js&"
import style0 from "./TerritorialAtlasCard.vue?vue&type=style&index=0&id=43f2a989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2a989",
  null
  
)

export default component.exports